import React from "react";
import { View } from "components/utils/View";
import { viewOptionSelector } from "~redux/slices/viewOptionSlice";
import { useRootSelector } from "~redux/hooks";
import {
  CpdlcHistory as BaseCpdlcHistory,
  cpdlcHistView,
  ViewOptionContextProvider,
} from "@poscon/shared-frontend";

/*
 * TI6110.100b - section 4.2.8.1
 * Message History View Format
 * The Message History View displays all **closed** CPDLC messages exchanged between
 * the local facility and the specified aircraft.
 */
export const CpdlcHistory = () => {
  const viewOptions = useRootSelector((state) => viewOptionSelector(state, cpdlcHistView));

  return (
    <ViewOptionContextProvider options={viewOptions}>
      <BaseCpdlcHistory ViewComponent={View} />
    </ViewOptionContextProvider>
  );
};
